export const getOptimizedPoints = async (waypoints) => {

    const API_KEY = '5ca93d12-4ee5-428f-9125-6f5971ea70cd';
    const baseURL = 'https://api.routing.yandex.net/v2/route';
    const params = new URLSearchParams({
        waypoints: prepareWaypoints(waypoints),
        apikey: API_KEY,
        mode: 'truck',
        traffic: 'disabled',
    });

    const url = `${baseURL}?${params.toString()}`;
    console.log(url);
    console.log()
    try {
        // Ожидание ответа от fetch
        const response = await fetch(url, {
            method: 'GET'
        });

        // Проверка на успешность запроса
        if (!response.ok) {
            throw new Error('Response was not ok: ' + response.statusText);
        }

        // Парсинг данных
        const data = await response.json();

        return data;
    } catch (e) {
        console.error(e);
    }
}

export const getDistanceMatrix = async (origins, destinations) => {
    const API_KEY = '5ca93d12-4ee5-428f-9125-6f5971ea70cd';
    const baseURL = 'https://api.routing.yandex.net/v2/distancematrix';

    const params = new URLSearchParams({
        origins: prepareWaypoints(origins),
        destinations: prepareWaypoints(destinations),
        apikey: API_KEY,
        mode: 'truck',
        traffic: 'disabled',
    });

    const url = `${baseURL}?${params.toString()}`;

    try {
        const response = await fetch(url, {
            method: 'GET'
        });

        if (!response.ok) {
            throw new Error('Response was not ok: ' + response.statusText);
        }

        const data = await response.json();
        return data;
    } catch (e) {
        console.error(e);
        return null;
    }
}

// Рекурсивная функция для поиска минимального маршрута
export const findOptimalRoute = async (waypoints, visited = [0], route = [waypoints[0]]) => {
    const fixedStartPoint = waypoints[0]; // Фиксированная начальная точка

    // Если все точки посещены (кроме первой)
    if (visited.length === waypoints.length) {
        return route;
    }

    // Берём последнюю посещённую точку как отправную
    const origins = [waypoints[visited[visited.length - 1]]];

    // Оставшиеся точки для маршрута
    const remainingDestinations = waypoints.filter((_, index) => !visited.includes(index));

    // Если больше нет доступных точек
    if (remainingDestinations.length === 0) {
        return route;
    }

    // Запрашиваем матрицу расстояний
    const data = await getDistanceMatrix(origins, remainingDestinations);
    if (!data || !data.rows || !data.rows[0] || !data.rows[0].elements) {
        return route; // Ошибка в запросе или нет данных
    }

    // Поиск минимального расстояния
    let minDistanceIndex = 0;
    let minDistance = data.rows[0].elements[0].distance.value;

    for (let i = 1; i < data.rows[0].elements.length; i++) {
        if (data.rows[0].elements[i].distance.value < minDistance) {
            minDistance = data.rows[0].elements[i].distance.value;
            minDistanceIndex = i;
        }
    }

    // Находим индекс выбранной точки в общем списке waypoints
    const selectedDestinationIndex = waypoints.indexOf(remainingDestinations[minDistanceIndex]);

    // Добавляем точку в маршрут и отмечаем как посещённую
    route.push(waypoints[selectedDestinationIndex]);
    visited.push(selectedDestinationIndex);

    // Рекурсивно вызываем функцию для следующего этапа маршрута
    return await findOptimalRoute(waypoints, visited, route);
};

export const findSortedByDistanceRoute = async (waypoints = [], origins = []) => {
    const result = [];
    if (!(waypoints.length > 0)) {
        return result;
    }
    const startPoints = origins.length > 0 ? origins : [waypoints[0]];
    try {
        const responseData = await getDistanceMatrix(startPoints, waypoints);
        const distances = responseData.rows[0].elements;

        const sortedIndexes = distances
            .map((item, index) => ({index, distance: item.distance.value}))
            .sort((a, b) => a.distance - b.distance)
            .map(item => item.index);

        sortedIndexes.forEach(index => {
            result.push(waypoints[index]);
        })
    } catch (e) {
        console.error(e);
    } finally {
        return result;
    }
}

function findMinDistanceIndex(response) {
    const elements = response.rows[0].elements;

    let minDistance = elements[0].distance.value; // Инициализируем минимальное значение первым элементом
    let minIndex = 0; // Индекс минимального значения

    // Проходим по массиву элементов
    for (let i = 1; i < elements.length; i++) {
        if (elements[i].distance.value < minDistance) {
            minDistance = elements[i].distance.value; // Обновляем минимальное значение
            minIndex = i; // Запоминаем индекс
        }
    }

    return minIndex;
}

const prepareWaypoints = (waypoints) => {
    return waypoints.map(element => {
        return [...element['coordinates']].reverse().join(',')
    }).join('|');
}